// Utilidad compartida para optimizar URLs de imágenes en Supabase Storage
export const getOptimizedUrl = (url, width = 600, quality = 75) => {
  if (!url) return null;
  if (!url.includes('supabase.co')) return url;
  // Evitar duplicar params si ya los tiene
  if (url.includes('?')) return url;
  return `${url}?width=${width}&format=webp&quality=${quality}`;
};
